export default "__VITE_ASSET__FFx6C38Q__"